var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crm-app",attrs:{"id":"app"}},[_c('TopBar'),_c('div',{staticClass:"main-container"},[_c('SideBar',{attrs:{"activeModule":_vm.activeModule},on:{"changeModule":_vm.changeModule}}),_c('PageContent',{attrs:{"activeModule":_vm.activeModule}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }